
export const GET_SETTING_PREFERENCE_REQUEST = 'GET_SETTING_PREFERENCE_REQUEST';
export const GET_USER_SETTINGS_REQUEST = 'GET_USER_SETTINGS_REQUEST';
export const GET_SETTING_PREFERENCE_SUCCESS = 'GET_SETTING_PREFERENCE_SUCCESS';
export const GET_SETTING_PREFERENCE_FAILURE = 'GET_SETTING_PREFERENCE_FAILURE';

export const getUserSettingsAction = () => ({
    type: GET_USER_SETTINGS_REQUEST
});

export const getSettingPreferences = () => ({
    type: GET_SETTING_PREFERENCE_REQUEST
});

export const getSettingPreferencesSuccess = data => ({
    type: GET_SETTING_PREFERENCE_SUCCESS, data
});

export const getSettingPreferencesFailure = () => ({
    type: GET_SETTING_PREFERENCE_FAILURE
});

export const SAVE_SETTING_PREFERENCE_REQUEST = 'SAVE_SETTING_PREFERENCE_REQUEST';
export const SAVE_SETTING_PREFERENCE_SUCCESS = 'SAVE_SETTING_PREFERENCE_SUCCESS';
export const SAVE_SETTING_PREFERENCE_FAILURE = 'SAVE_SETTING_PREFERENCE_FAILURE';

export const saveSettingPreferences = request => ({ type: SAVE_SETTING_PREFERENCE_REQUEST, request, isSaveInProgress: true });

export const saveSettingPreferencesSuccess = () => ({ type: SAVE_SETTING_PREFERENCE_SUCCESS, isSaveInProgress: false });

export const saveSettingPreferencesFailure = () => ({ type: SAVE_SETTING_PREFERENCE_FAILURE, isSaveInProgress: false });



// WEBPACK FOOTER //
// ./app/containers/privacy-settings/actions.js